import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../actions/index';
import Workday from './workday';
import ActivityModal from './activity-modal';
import HoursOfServiceModal from './hours-of-service-modal';
import CommentsModal from './comments-modal';
import NotesModal from './notes-modal';
import PayperiodModal from './payperiod-modal';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/src/SuperResponsiveTableStyle.css';
import {constants, KeolisSpinner, moment} from './common/commonExport';
import AdminCommonSection from '../components/adminLayout';
import apiConst from '../../../constants/const'

class UserHosLogWorkdays extends React.Component {

    constructor(props) {
        super(props);
        this.currentPageNum = 1;
    }

    // get workdays when loading workdays component
    fetchWorkdays(fetchObj) {
        this.props.fetchWorkdays(fetchObj);
    }

    // handling pagination
    handlePagination(event) {
        
        let empId = this.props.authDetails.impersonateUserId > 0? this.props.authDetails.impersonateUserId:this.props.authDetails.employeeID;
        switch (event) {
            case "first":
                this.currentPageNum = 1;
                break;
            case "prev":
                this.currentPageNum = this.currentPageNum - 1;
                break;
            case "next":
                this.currentPageNum = this.currentPageNum + 1;
                break;
            case "last":
                this.currentPageNum = this.props.pageNum;
                break;
        }
        this.fetchWorkdays(constants.actionUrls.EMPLOYEE_HOS_LOGS_URL, empId, this.currentPageNum);
    }

    // called before render of component
    componentWillMount() {
        let empId = this.props.authDetails.impersonateUserId > 0? this.props.authDetails.impersonateUserId:this.props.authDetails.employeeID,
        
            fetchObj = {
            url:constants.actionUrls.EMPLOYEE_HOS_LOGS_URL,
            role: 'emp',
            empId:empId,
            source: 'web',
            pageNum:1
        }
        if (empId) {
            this.currentPageNum = 1;
            localStorage.setItem('empId', empId);
            this.fetchWorkdays(fetchObj);
        }
    }

    // rendering different modals as needed
    renderModal() {

        if(this.props.notesObj.notesObj && this.props.notesObj.notesObj.showNotesModal){
            var modalStatus = this.props.notesObj.notesObj.showNotesModal;
            var modalName = this.props.notesObj.notesObj.modalName;
        } else {
            var modalStatus = this.props.showModal;
            var modalName = this.props.modalName;
        }
        if (modalStatus && modalName == "notes_Modal") {
            return (<NotesModal/>)
        } else if (modalStatus && modalName == constants.hosModals.Certify_Modal || modalName == constants.hosModals.Certified_Modal) {
            return (<ActivityModal isLogUser = {true}  islogAdmin = {this.props.authDetails.impersonateUserId > 0 && !apiConst.isImpersonateEditAllow} isWorkDaychange={this.props.workday.change} />)
        } 
        else if (modalStatus && modalName == constants.hosModals.Comments_Modal) {
            
            return (<CommentsModal islogsUser = {true} />)
        }
    }

    checkPrevNonCertifiedWokrday(row, workdays) {
        let nonCertifiedWorkdays,
            wdy_date = row.wdy_date;
        //not certified   
        nonCertifiedWorkdays = workdays.filter(function (value, index) {
            return value.wdy_certify_status === 'U' && value.dutyActivityStatus === 'Y';
        });

        //filtered is after the current row workdate date 
        let filtered = nonCertifiedWorkdays.filter(function (value) {
            
            //get restbreak records filtering with current row date 
            let hasRestBreakRecord = nonCertifiedWorkdays.filter(value => {
                return value.wdy_date === wdy_date
            })
            //length greater than 1 will be rest break records
            if(hasRestBreakRecord.length > 1){
                let result = false;
                hasRestBreakRecord.every(function(element){
                    // check date of restbreak and current records && resbreak numbers are same  - 
                        // yes -> return isAfter for the date for restbreakno 1 (normal scenario)
                        // yes -> return isSameOrAfter for number 2, as restbreak 1&2 will the same date
                    if(wdy_date == element.wdy_date &&  row.RestBreakNo == element.RestBreakNo){
                        if(element.RestBreakNo == 1){
                            return result = moment(wdy_date, "MM-DD-YYYY").isAfter(moment(element.wdy_date, "MM-DD-YYYY"))
                        }
                        else if(element.RestBreakNo == 2){
                            return result = moment(wdy_date, "MM-DD-YYYY").isSameOrAfter(moment(element.wdy_date, "MM-DD-YYYY"))
                        }
                    }
                });
                return result;
            }
            else 
                return moment(wdy_date, "MM-DD-YYYY").isAfter(moment(value.wdy_date, "MM-DD-YYYY"))
        });
        //return editable true if array contains nothing
        return filtered.length <= 0;
    }


    getEditIconValue(workday){
        var workdays = this.props.workdays;
        let editable =  this.checkPrevNonCertifiedWokrday(workday, workdays);
        var data = workdays.filter(function(item){  
            return item.Workday_id == workday.Workday_id && item.RestBreakNo == workday.RestBreakNo;
        });
        if(data != null){
            if(editable){
                if(data.length > 1){
                    var workId = -1;
                    var amendmentId = -1;
                    data.forEach(work => {
                        if(parseInt(work.AmendmentId) > parseInt(amendmentId)) {
                            amendmentId = parseInt(work.AmendmentId);
                            workId = work.id;
                        }
                        if(workday.id == workId)
                            editable = true;
                        else
                            editable = false
                    })
                }
            }
            return editable;
        }
        return editable;
    }

    getEditIcon(){
        let workdays = this.props.workdays;
        var array = [];
        workdays.forEach(workday => {
            let value = this.getEditIconValue(workday);
            array.push(value);
        });
        return array;
    }

    // render workdays
    renderWorkdays() {
        var iconArray = this.getEditIcon();
        var workdays = this.props.workdays, role = this.props.authDetails.impersonateUserId > 0?constants.roles.EMPLOYEE_ROLE:this.props.authDetails.role;
        if (workdays && workdays.length > 0) {
            return (
                workdays.map(function (workday, index) {
                    return (<Workday isEditable={iconArray[index]} workday={workday} key={index + workday.wdy_date} role={role} menutype = 'HosDetails'/>);
                })
            )
        }
        else if (this.props.hasErrored) {
            return <div>Sorry some Error...</div>;
        } else if (this.props.isLoading) {
            return (
                <tr>
                    <td>
                        <KeolisSpinner />
                    </td>
                </tr>
            )
        } else {
            return (
                <tr>
                    <td colSpan="100%">
                        No Records Available
                    </td>
                </tr>
            )
        }
    }

    // rendering pagination component
    renderPagination() {
        return (
            <div id="pageNumber">
                {
                    this.currentPageNum == 1 ?
                        <button className="btn btn-default firstPage disabled">❮❮</button>
                        : <button className="btn btn-default firstPage" onClick={() => this.handlePagination("first")}>❮❮</button>
                }
                {
                    this.currentPageNum == 1 ?
                        <button className="btn btn-default prevPage disabled">❮</button>
                        : <button className="btn btn-default prevPage" onClick={() => this.handlePagination("prev")}>❮</button>
                }
                {
                    (this.currentPageNum == this.props.pageNum) ?
                        <button className="btn btn-default nextPage disabled">❯</button>
                        : <button className="btn btn-default nextPage" onClick={() => this.handlePagination('next')}>❯</button>
                }
                {
                    (this.currentPageNum == this.props.pageNum) ?
                        <button className="btn btn-default lastPage disabled">❯❯</button>
                        : <button className="btn btn-default lastPage" onClick={() => this.handlePagination('last')}>❯❯</button>
                }
            </div>
        )
    }
    showModal(modalName){
        
        this.props.onShowModal(modalName);
    }

    onRefresh(){
        let workday_date = Array.isArray(this.props.workdays) && this.props.workdays.length > 0 ? this.props.workdays[0].wdy_date : '';
        let workday_date_formated = workday_date ? moment(workday_date, 'MM/DD/YYYY').format('YYYYMMDD') : '';
        
        let empId = this.props.authDetails.impersonateUserId > 0? this.props.authDetails.impersonateUserId:this.props.authDetails.employeeID,
            fetchObj = {
            url:constants.actionUrls.EMPLOYEE_HOS_LOGS_URL,
            role: 'emp',
            empId:empId,
            source: 'web',
            pageNum:1,
            workdayDate: workday_date_formated,
            pay_certify_status: this.props.workdays.length > 0 ? this.props.workdays[0].wdy_certify_status_pay : '',
            isRefresh : true
        }
        this.fetchWorkdays(fetchObj);
    }
    render() {
        const { printStatus } = this.props.printState;
        const refreshed_time = Array.isArray(this.props.workdays) && this.props.workdays.length > 0 && this.props.workdays[0].refreshed_time ? this.props.workdays[0].refreshed_time : '';
        let compTitle = "My Hours of Service"
        return (
            <AdminCommonSection compTitle={compTitle} refreshTime={refreshed_time}  admin={false} onRefresh={this.onRefresh.bind(this)}
                tblBody={
                    <div>
                        <div id="tblMainActivities" className={"employeeTbl " + (this.props.authDetails.role != constants.roles.ADMIN_ROLE ? 'spaceFromBottom' : '')} >
                            <Table className="table table-striped table-bordered_header table-condensed">
                                <Thead className="thead-default">
                                    <Tr>
                                        <Th>Service Date</Th>
                                        <Th>Type</Th>
                                        <Th className="hidden">14 Cycle</Th>
                                        <Th className="text-center">Total HOS</Th>
                                        <Th className="text-center">Status</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                {
                                    this.renderWorkdays()
                                }
                                </Tbody>
                            </Table>
                            {
                                this.renderModal()
                            }
                        </div>
                </div>
                }
            />
        );
    }
}

function mapStateToProps(state) { // coming from store
    return {
        workdays: state.workdays.workdays,
        pageNum: state.workdays.pageNum,
        hasErrored: state.workdays.itemsHasErrored,
        isLoading: state.workdays.isLoading,
        showModal: state.modals.showModal,
        modalName: state.modals.modalName,
        workday: state.workday.workday,
        activities: state.workdays.activities,
        authDetails: state.authState,
        printState:state.printState,
        notesObj:state.notes
      
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            onShowModal: actions.showModalAction,
            fetchWorkdays: actions.fetchhoslogsWorkdays,
            notify:actions.notifyAction
        }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(UserHosLogWorkdays);